import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { cn } from './cn';

interface Props {
  /** Optional explicit route. When omitted, falls back to history.back(). */
  to?: string;
  /** Override the label. Defaults to common.back i18n key. */
  label?: string;
  className?: string;
  testId?: string;
}

export function BackButton({ to, label, className, testId }: Props): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const text = label ?? t('common.back');
  return (
    <button
      type="button"
      onClick={() => (to ? navigate(to) : navigate(-1))}
      data-testid={testId ?? 'back-button'}
      className={cn(
        'inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground',
        className,
      )}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 20 20"
        fill="currentColor"
        className="h-4 w-4"
      >
        <path
          fillRule="evenodd"
          d="M12.707 5.293a1 1 0 0 1 0 1.414L9.414 10l3.293 3.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z"
          clipRule="evenodd"
        />
      </svg>
      {text}
    </button>
  );
}
